import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

// project-imports
// import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import ComponentsRoutes from './ComponentsRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import MainLayout from 'layout/MainLayout';


import AuthGuard from 'utils/route-guard/AuthGuard';

// render - landing page
const PagesLanding = Loadable(lazy(() => import('pages/dashboard/default')));
// const AppProviderList = Loadable(lazy(() => import('pages/apps/customer/list_provider')));
// ==============================|| ROUTES RENDER ||============================== //

export default function ThemeRoutes() {


  return useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ), 
      children: [
        {
          path: '/',
          element: <PagesLanding />
        }
      ]
    },
    LoginRoutes,
    ComponentsRoutes,
    MainRoutes
  ]);
}
